module.exports = __webpack_public_path__ + "static/media/service.cacd2ee6.png";